$(document).ready(function () {
  // dog weight calculator code start
  $("#dogWeight").on("change paste keyup", function () {
    var currentVal = $(this).val();
    $('.product-form__submit').prop("disabled", false);
    console.log(currentVal);
    if (currentVal == "") {
      $(this).val("");
      $(".addOnProductMessage").text("");
      $(".extraAddOnProduct").hide();
      $(".requiredPupStack").text("x 0");
      $(".customAddOnProdBtn").attr("disabled", "");
      $(".customAddOnProdBtn").attr("data-qty", "0");
    } else if (currentVal < 1) {
      $(this).val(1);
      $(".addOnProductMessage").text(
        "Your dog does not require any additional Pup Stack weights according to our standard guidelines."
      );
      $(".extraAddOnProduct").show();
      $(".requiredPupStack").text("x 0");
      $(".customAddOnProdBtn").removeAttr("disabled");
      $(".customAddOnProdBtn").attr("data-qty", "0");
    } else if (currentVal <= 12) {
      $(".addOnProductMessage").text(
        "Your dog does not require any additional Pup Stack weights according to our standard guidelines."
      );
      $(".extraAddOnProduct").show();
      $(".requiredPupStack").text("x 0");
      $(".customAddOnProdBtn").removeAttr("disabled");
      $(".customAddOnProdBtn").attr("data-qty", "0");
    } else if (currentVal <= 22) {
      $(".addOnProductMessage").text(
        "Your dog requires 1 additional Pup Stack weight."
      );
      $(".extraAddOnProduct").show();
      $(".requiredPupStack").text("x 1");
      $(".customAddOnProdBtn").removeAttr("disabled");
      $(".customAddOnProdBtn").attr("data-qty", "1");
    } else if (currentVal <= 32) {
      $(".addOnProductMessage").text(
        "Your dog requires 2 additional Pup Stack weights."
      );
      $(".extraAddOnProduct").show();
      $(".requiredPupStack").text("x 2");
      $(".customAddOnProdBtn").removeAttr("disabled");
      $(".customAddOnProdBtn").attr("data-qty", "2");
    } else if (currentVal <= 40) {
      $(".addOnProductMessage").text(
        "Your dog requires 3 additional Pup Stack weights."
      );
      $(".extraAddOnProduct").show();
      $(".requiredPupStack").text("x 3");
      $(".customAddOnProdBtn").removeAttr("disabled");
      $(".customAddOnProdBtn").attr("data-qty", "3");
    } else {
      $(".addOnProductMessage").text(
        "The Pup stack is only recommend for most dogs under 40 pounds."
      );
      $(".extraAddOnProduct").hide();
      $(".customAddOnProdBtn").removeAttr("disabled");
      $(".customAddOnProdBtn").attr("disabled", "");
      $(".customAddOnProdBtn").attr("data-qty", "1");
    }
  });
  // dog weight calculator code end
  $("#clearBtn").click(function () {
    $("#dogWeight").val("");
    $(".addOnProductMessage").text("");
    $(".extraAddOnProduct").hide();
    $(".requiredPupStack").text("x 0");
    $(".customAddOnProdBtn").attr("disabled", "");
    $(".customAddOnProdBtn").attr("data-qty", "0");    
    $('.product-form__submit').prop("disabled", true);
  });

});
